import { statementsEnrollmentUrl } from "./endpoints.js";
const statementsEnrollmentCacheKey = ({
  accountId,
  accountIdType
}) => [statementsEnrollmentUrl, { accountId, accountIdType }];
export {
  statementsEnrollmentCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
